export default __webpack_public_path__ + "static/media/auto_dispatch.46740a4e.svg";